import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import StandardPage from "./components/common/StandardPage";
import "./App.css";
import "./fonts.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import CasePage from "./pages/CasePage";
import sw from "./assets/img/sweekend.jpg";
import techgenius from "./assets/img/techgenius.jpg";
import uzum from "./assets/img/uzummeetup.jpg";
import digitalvalley from "./assets/img/digitalvalleycamp.jpg";
import brbhackcelerator from "./assets/img/brbhackcelerator.jpg";
import sqbhackathon from "./assets/img/sqbhackathon.jpg";
import bioversity from "./assets/img/cgiar.jpg";
import yesu from "./assets/img/yesu.jpg";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

function App() {
  const location = useLocation();

  return (
    <StandardPage>
      <Navbar />
      <AnimatePresence
        mode="wait"
        onExitComplete={() => {
          if (typeof window !== "undefined") {
            window.scrollTo({ top: 0, behavior: "instant" });
          }
        }}
      >
        {AppRoutes(location)}
      </AnimatePresence>
      <Footer />
    </StandardPage>
  );
}

export const cases = [
  {
    path: "/startupweekend",
    // content: <Markdown>{startupweekendcontent}</Markdown>,
    meta: {
      title: "Techstars Startup Weekend",
      description:
        "As the official 2026 partner, Hackonnect brings Techstars Startup Weekend to Uzbekistan. Learn how we scale startups nationwide from Bukhara to Qarshi.",
      image: sw,
      website: "https://startupweekend.uz/",
      video: "https://www.youtube.com/embed/mlbaSwn4mn0",
    },
  },
  {
    path: "/brb-hackcelerator",
    meta: {
      title: "BRB Fintech Hackcelerator",
      description:
        "Discover how Hackonnect delivered 5 FinTech MVPs and a streamlined IT recruitment funnel for BRB, engaging 250+ developers and 10+ industry mentors.",
      image: brbhackcelerator,
      website:
        "https://brb.uz/axborot-markazi/brb-fintech-hackcelerator-it-tanlovi-boshlangani-elon-qilindi",
    },
  },
  {
    path: "/sqb-ventures-hackathon",
    meta: {
      title: "SQB Ventures Hackathon",
      description:
        "See how SQB Ventures built a robust startup pipeline with Hackonnect. 191 teams, 13 MVPs, and successful IP transfer to accelerate banking innovation.",
      image: sqbhackathon,
      website:
        "https://sqb.uz/uz/news/sqb-ventures-hackathon-it-tanlovi-boshlangani-elon-qilindi",
    },
  },
  {
    path: "/techgenius",
    // content: <Markdown>{techgenius}</Markdown>,
    meta: {
      title: "Tech Genius",
      description:
        "Empowering graduates through the TechGenius Hackathon. 120 participants and 24 solutions developed for UNDP Uzbekistan and the Ministry of Economy.",
      image: techgenius,
      website: "https://techgenius.uz/",
    },
  },
  {
    path: "/uzum-tech-meetup",
    meta: {
      title: "Uzum Tech Meetup",
      description:
        "Hackonnect helped UZUM showcase its technical culture to 4,000+ people, resulting in 240+ registrations and high-quality hires for its tech ecosystem.",
      image: uzum,
    },
  },
  {
    path: "/digital-valley-camp",
    meta: {
      title: "Digital Valley Camp",
      description:
        "Empowering Central Asian youth through the Digital Valley IT Camp. A cross-border program fostering regional friendship and tech collaboration for social good.",
      image: digitalvalley,
    },
  },
  {
    path: "/bioversity-cgiar",
    meta: {
      title: "Bioversity CGIAR",
      description:
        "Discover how Hackonnect applied its ecosystem-building expertise to successfully guide CGIAR-led agtech startups to a new market through a 3-month online acceleration program, resulting in attracted investments.",
      image: bioversity,
    },
  },
  {
    path: "/yesu",
    meta: {
      title: "YESU",
      description:
        "Discover how Hackonnect applied its ecosystem-building expertise to successfully guide CGIAR-led agtech startups to a new market through a 3-month online acceleration program, resulting in attracted investments.",
      image: yesu,
    },
  },
];

const AppRoutes = (location) => (
  <Routes key={location.pathname} location={location}>
    {cases.map((r) => (
      <Route key={r.path} path={r.path} element={<CasePage meta={r.meta} />} />
    ))}
    <Route path="/contact" element={<Contact />} />
    <Route index element={<Home />} />
    {/* <Route path="*" element={<NotFoundPage />} /> */}
  </Routes>
); 

export default App;
